import { useStore } from "../../../app/data/root.store";
import { AssetClassIcon } from "../../../assets/components/AssetClassIcon";
import { VaultClassTagIconWrapper, VaultListTagWrapper, VaultListTagWrapperText } from "./VaultListTags.styles";

export const VaultClassTags = ({ linkedAssets, minimized, alwaysShow = false }) => {

    const { metadataStore } = useStore();

    const isMinimized = (minimized && (linkedAssets.length > 1));
    const displayItems = isMinimized ? linkedAssets.slice(0, 1) : linkedAssets;
    if (!displayItems.length) return null;

    return (
        displayItems.map((item, index) => {
            const asset = item.asset || item;
            const assetId = asset.id;
            const categoryId = asset.categoryId;
            
            let assetTitle = asset.title || asset.name;
            if (!assetTitle && assetId) {
                const allAssets = [...(metadataStore.assetsWithoutCashAccount || []), ...(metadataStore.cashAccounts || [])];
                const foundAsset = allAssets.find(a => a.id === assetId);
                assetTitle = foundAsset?.title || foundAsset?.name;
            }
            
            const categoryObj = metadataStore.categories?.find(cat => cat.id === categoryId);
            const classObj = categoryObj ? metadataStore.classes?.find(cls => cls.id === categoryObj.classId) : null;

            const color = classObj?.color || "#E9EAEB";
            const icon = classObj?.icon || "default";
            
            const fallbackName = assetId ? `Asset ${assetId}` : 'Linked Asset';
            const displayName = isMinimized ? `${linkedAssets.length} items` : (assetTitle || fallbackName);

            return (
                <VaultListTagWrapper key={index} alwaysShow={alwaysShow}>
                    <VaultClassTagIconWrapper bgColor={color}>
                        <AssetClassIcon name={icon} />
                    </VaultClassTagIconWrapper>
                    <VaultListTagWrapperText>{displayName}</VaultListTagWrapperText>
                </VaultListTagWrapper>
            );
        })
    );
}